import { createSelector } from 'reselect';

import { editorSelector } from 'modules/editor/store/selectors/editor';

export const loadingElementsSelector = createSelector(
  editorSelector,
  (editor) => editor.loadingElements,
);
